// A buyer contact can legitimately have no organization — they have no
// `org_users` row (GEA-4987). Reports group and label by organization, so they
// need one agreed bucket for those customers rather than four copies of the
// same magic string.

/** Grouping key for customers with no organization. Not a real organization id. */
export const NO_ORG_ID = 'no-organization'

/** What an absent organization is called wherever we show its name. */
export const NO_ORG_NAME = 'No Organization'

/** Group-by key for a customer's organization, bucketing the org-less together. */
export const orgKey = (org: { id: string } | null | undefined): string => org?.id ?? NO_ORG_ID

/** Display name for an organization looked up out of an `orgById` map. */
export const orgName = (org: { name: string } | null | undefined): string =>
  org?.name ?? NO_ORG_NAME

export default { NO_ORG_ID, NO_ORG_NAME, orgKey, orgName }
